import { useState } from "@wordpress/element";
import Stepper from "vino/core/Stepper";
import ShippingAddress from "./steps/ShippingAddress";
import Payment from "./steps/Payment";
import SubscriptionDetails from "./steps/SubscriptionDetails";

const steps = [
	{
		id: 1,
		name: "Subscription",
	},
	{
		id: 2,
		name: "Shipping information",
	},
	{
		id: 3,
		name: "Payment",
	},
];

const Subscription = () => {
	const [activeStep, setActiveStep] = useState(0);

	const handleChangeActiveStep = (newActiveStep) => {
		if (activeStep > newActiveStep) {
			setActiveStep(newActiveStep);
		}
	};

	const handleNext = () => {
		setActiveStep(activeStep + 1);
	};

	const handleBack = () => {
		setActiveStep(activeStep - 1);
	};

	return (
		<div className="flex flex-col w-full mt-10">
			<div className="flex justify-center w-full">
				<div className="w-full max-w-3xl">
					<Stepper
						classes={{ root: "bg-transparent" }}
						activeStep={activeStep}
						steps={steps}
						onClick={handleChangeActiveStep}
					/>
				</div>
			</div>
			<div className="flex justify-center w-full">
				<div className="w-full overflow-auto max-w-2xl">
					{activeStep === 0 && <SubscriptionDetails onNext={handleNext} />}
					{activeStep === 1 && (
						<ShippingAddress onBack={handleBack} onNext={handleNext} />
					)}
					{activeStep === 2 && (
						<Payment onNext={handleNext} onBack={handleBack} />
					)}
				</div>
			</div>
		</div>
	);
};

export default Subscription;
